// After focusing out of the title field, hide or show the error as appropriate and optionally run a callback
window.setUpActivityCard = (containerElement, callback) => {
    containerElement.addEventListener("focusout", (e) => {
        if (e.target.classList.contains("activity-title")) {
            const title = e.target;
            const error = title.closest(".activity-card").querySelector(".vb_error__container");
            // If the string is empty or only white space, show the error. Otherwise hide it
            title.value.trim() === "" ? showVbError(error) : hideVbError(error);
            if (callback) callback();
        }
    })
}
